export type Method = (...args: unknown[]) => unknown;

export type Request = {
  id: string;
  method: string;
};

export type Response<T = unknown> = {
  id: string;
  result: T;
};

export function isResponse(msg: unknown): msg is Response {
  return typeof msg === 'object' && msg !== null && 'id' in msg && 'result' in msg;
}

export function isRequest(msg: unknown): msg is Request {
  return typeof msg === 'object' && msg !== null && 'id' in msg && 'method' in msg;
}
